<template>
  <ul v-if="isCompleted">
    <li>
      <ChapterCompletedScore :score="scoreOn20" :title="title" />
    </li>
    <li v-if="!profile.isParent && score >= 0.6">
      <ChapterCompletedShare
        :category="category"
        :score="score"
        :title="title"
        class="button-share"
      />
    </li>
  </ul>
</template>
<script setup lang="ts">
interface Props {
  category: CategorySchema;
}

const props = defineProps({
  category: null
});

const { chapter } = inject(INJECT_CATEGORY_PAGE);

const profile = useProfileStore();

const { progressions: allProgressions } = inject(INJECT_PROGRESSION_EXERCISES);

const exerciseIds = computed(() => {
  if (!props.category.exercises) return [];
  return props.category.exercises.map((exercise) => exercise.id);
});

const title = computed(() => {
  return chapter.value ? chapter.value.title : props.category.title;
});

const { score, scoreOn20, isCompleted } = useExercisesChapterProgressions(
  allProgressions,
  exerciseIds
);
</script>
<style lang="scss" scoped>
ul {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--gap_n);
  @include above('l') {
    grid-template-columns: 1fr 1fr;
    &:has(li:only-child) {
      grid-template-columns: 1fr;
    }
  }
}
</style>
